module.exports = __webpack_public_path__ + "img/app_icon_53.5c792316.png";